// extracted by mini-css-extract-plugin
export default {"app-breadcrumb":"Breadcrumb__app-breadcrumb___pAEiO","title":"Breadcrumb__title___r2Sq6"};